import {FETCH_TRENDING_REQUEST, FETCH_TRENDING_SUCCESS, FETCH_TRENDING_ERROR} from "../actions/trending"

const initialState = {
    isLoaded: false,
    isLoading: false,
    trending: []
}

const trending = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TRENDING_REQUEST:
            return {
                ...state,
                isLoading: true,
            }
        case FETCH_TRENDING_SUCCESS:
            return {
                ...state,
                isLoaded: true,
                isLoading: false,
                trending: action.payload
            }
        case FETCH_TRENDING_ERROR:
            return {
                ...state,
                isLoaded: true,
                isLoading: false
            }
        default:
            return state
    }
}

export default trending



// WEBPACK FOOTER //
// ./src/reducers/trending.js